// extracted by mini-css-extract-plugin
export default {"OrderReturnModal":"styles_OrderReturnModal__fxYlH","markAsPaidDateBoxWrapper":"styles_markAsPaidDateBoxWrapper__CDVeG"};